import {client} from "@/store";

export default {
	namespaced: true,

	state: {
		viewer: null,
		privileges: []
	},

	// sync actions
	mutations: {
		setViewer(state, value) {
			state.viewer = value;
		},

		setPrivileges(state, value) {
			state.privileges = value;
		}
	},

	getters: {
		loggedIn: (state) => {
			return state.viewer != null;
		},
		allowedTo: (state) => (requestedPrivilege) => {
			let privileged = false;
			for (const key in Object.entries(state.privileges)) {
				if ((Array.isArray(requestedPrivilege) && requestedPrivilege.includes(state.privileges[key].name)) || (typeof requestedPrivilege === "string" && requestedPrivilege === state.privileges[key].name)) {
					privileged = true;
					break;
				}
			}
			return privileged;
		}
	},

	actions: {
		fetchViewer({
			commit,
			state,
			dispatch
		}, data) {
			const query = `
			query {
				viewer {
					id
					display_name
					username
					privileges {
						name
						allowed
						label
					}
					employee {
						fullname
					}
				}
			}`;

			return new Promise((resolve, reject) => {
				commit("setLoading", null, {root: true});
				client.query(query, {...data}).then(result => {
					commit("setIdle", null, {root: true});

					if (result.viewer) {
						commit("setViewer", result.viewer);
						commit("setPrivileges", result.viewer.privileges);
						resolve();
					} else {
						commit("setViewer", null);
						commit("setPrivileges", null);
						reject();
					}
				});
			});
		},

		loginUser({
			commit,
			state,
			dispatch
		}, data) {
			const query = `
			query ($username: String, $password: String) {
				login(username: $username, password: $password)
				viewer {
					id
					display_name
					username
					privileges {
						name
						allowed
					}
					employee {
						fullname
					}
				}
			}`;

			return new Promise((resolve, reject) => {
				commit("setLoading", null, {root: true});
				client.query(query, {...data}).then(result => {
					commit("setIdle", null, {root: true});
					if (result.login === "otp_required") {
						resolve("otp_required");
						return;
					}
					if (result.login) {
						dispatch("loadConfig", null, {root: true});
						commit("setViewer", result.viewer);
						commit("setPrivileges", result.viewer.privileges);
						resolve(result.viewer);
					} else {
						commit("setViewer", null);
						commit("setPrivileges", null);
						reject();
					}
				});
			});
		},

		verifyTotp({
			commit,
			state,
			dispatch
		}, data) {
			const query = `
			query ($code: String, $trusted_device: Boolean) {
				verifyTotp(code: $code, trusted_device: $trusted_device)
				viewer {
					id
					display_name
					username
					privileges {
						name
						allowed
					}
					employee {
						fullname
					}
				}
			}`;

			return new Promise((resolve, reject) => {
				commit("setLoading", null, {root: true});
				client.query(query, {...data}).then(result => {
					commit("setIdle", null, {root: true});
					if (result.verifyTotp) {
						dispatch("loadConfig", null, {root: true});
						commit("setViewer", result.viewer);
						commit("setPrivileges", result.viewer.privileges);
						resolve(result.viewer);
					} else {
						commit("setViewer", null);
						commit("setPrivileges", null);
						reject();
					}
				});
			});
		},

		logoutUser({commit}) {
			const query = `
			query {
				logout
			}`;

			return new Promise((resolve, reject) => {
				commit("setLoading", null, {root: true});
				client.query(query).then(result => {
					commit("setIdle", null, {root: true});
					commit("setViewer", null);
					commit("setPrivileges", []);
				});
			});
		}
	}
};
